"t";

import { useState } from "react";
import { Box, Typography, Grid, useMediaQuery, useTheme } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { styled } from "@mui/material/styles";
import BusinessOutcomes from "./Home/BusinessOutcomes";

const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  flexDirection: "column",
  padding: "60px 24px",
  position: "relative",
  overflow: "hidden",
  width: "100%",
  margin: "0 auto",
  "&::after": {
    content: '""',
    position: "absolute",
    width: "75%",
    height: "60%",
    left: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
    //backdropFilter: "blur(500px)",
    zIndex: 0,
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
}));

const StyledCardContainer = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "left",
  color: "white",
  borderRadius: "24px",
  overflow: "hidden",
  cursor: "pointer",
  padding: theme.spacing(4),
  width: '100%',
  minHeight:"385px",
  background: "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)" ,/* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */
  [theme.breakpoints.down("sm")]: {
    minHeight:"100%",
  },
}));

const getCardWidth = (isExpanded, isMobile, isTablet) => {
  if (isMobile) return "98%";
  if (isTablet) return isExpanded ? "100%" : "48%";
  return isExpanded ? "700px" : "250px";
};

const CardSwapSectionComponent = ({ data, title, subTitle }) => {
  const [expanded, setExpanded] = useState(data?.[0]?.id || null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md"));

  return (
    <MainContainer>
      <ContentContainer>
        <Typography variant="h2" sx={{
          background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontSize: { xs: "28px", sm: "32px", md: "40px" },
          fontWeight: 700,
          mb: {xs:2,md:4},
          textAlign: 'start',
          display:'flex',
          justifyContent: 'flex-start'
        }}>
          {title}
        </Typography>
        <Typography sx={{
          color: "#8C8CC2",
          fontSize: { xs: "16px", md: "18px" },
          lineHeight: 1.8,
          mb: {xs:5 ,md:10}
        }}>
          {subTitle}
        </Typography>

        <Box display="flex"  gap={1}  sx={{ width: "100%" ,flexDirection: {xs:"column" ,md:"row"} ,flexWrap: {xs:"wrap" ,md:"nowrap"} }}>
          {/* {data?.map((card) => (
            <StyledCardContainer
              key={card.id}
              onMouseEnter={() => setExpanded(card.id)}
              onMouseLeave={() => setExpanded(data[0].id)}
              animate={{ width: getCardWidth(expanded === card.id, isMobile, isTablet) }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              <AnimatePresence mode="wait">
                <motion.div
                  key={expanded === card.id ? "expanded" : "collapsed"}
                  initial={{ opacity: 1, y: 100 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 1, y: -300 }}
                  transition={{ duration: 0.7 }}
                  style={{ width: "100%", height: "100%" }}
                >
                  {expanded === card.id ? (
                    <Grid container spacing={2} alignItems="center" height="100%">
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between", // Ensures title is at top & description at bottom
                          height: "100%", // Make sure the container takes full height
                        }}
                      >
                        <Typography
                          variant="h5"
                          fontWeight="bold"
                          sx={{
                            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem", width:"50%" },
                          }}
                        >
                          {card.title}
                        </Typography>

                        <Typography
                          variant="body1"
                          sx={{
                            color: "#8C8CC2",
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                          }}
                        >
                          {card.description}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6} sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                        <img src={card.image} alt="Card Image" style={{
                          borderRadius: "12px",
                          width: "100%",
                          height: "100%",
                          maxHeight: "400px",
                          objectFit: "cover",
                        }} />
                      </Grid>
                    </Grid>
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="space-between"
                      height="100%"
                    >
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: { xs: "2.5rem", sm: "4rem", md: "5.75rem" },
                          mb: 2
                        }}
                      >
                        0{card.id}
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: { xs: "1rem", sm: "1.75rem" },
                        }}
                      >
                        {card.title}
                      </Typography>
                    </Box>
                  )}
                </motion.div>
              </AnimatePresence>
            </StyledCardContainer>
          ))} */}
          <BusinessOutcomes items={data} />
        </Box>
      </ContentContainer>
    </MainContainer>
  );
};

export default CardSwapSectionComponent;
